const EASTERN_TIME_ZONE = 'America/New_York';

/** Shown after formatted API timestamps (API sends UTC; display is US Eastern). */
export const EASTERN_TIME_LABEL = 'EST';

function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getZonedParts(date, timeZone = EASTERN_TIME_ZONE) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  return formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});
}

export function formatInEasternTime(value, options = {}) {
  const date = toDate(value);
  if (!date) return '—';

  const { appendEasternLabel = true, ...intlOptions } = options;
  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TIME_ZONE,
    ...intlOptions,
  }).format(date);

  return appendEasternLabel ? `${formatted} (${EASTERN_TIME_LABEL})` : formatted;
}

export function formatEasternDateTime(value) {
  return formatInEasternTime(value, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function formatEasternDate(value, options = {}) {
  return formatInEasternTime(value, {
    dateStyle: 'medium',
    ...options,
  });
}

export function toDateTimeLocalInEastern(value) {
  const date = toDate(value);
  if (!date) return '';

  const parts = getZonedParts(date);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function fromDateTimeLocalInEastern(value) {
  if (!value) return null;

  const match = String(value).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/
  );

  if (!match) return null;

  const [, y, m, d, hh, mm] = match;
  const utcGuess = new Date(Date.UTC(
    Number(y),
    Number(m) - 1,
    Number(d),
    Number(hh),
    Number(mm)
  ));

  let resolved = utcGuess;
  for (let i = 0; i < 3; i += 1) {
    const parts = getZonedParts(resolved);
    const expectedUtc = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );
    const targetUtc = Date.UTC(
      Number(y),
      Number(m) - 1,
      Number(d),
      Number(hh),
      Number(mm)
    );
    const delta = expectedUtc - targetUtc;
    if (delta === 0) break;
    resolved = new Date(resolved.getTime() - delta);
  }

  return resolved.toISOString();
}

